import * as React from "react";
import PropTypes from "prop-types";

const IconCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : "24"}
    height={props.height ? props.height : "24"}
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill={props.color ? props.color : "#2DCE89"}
      transform="matrix(-1 0 0 1 24 0)"
    ></circle>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15.667 8.5 9.25 14.917 6.333 12"
    ></path>
  </svg>
);

IconCheck.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

export default IconCheck;
